export const LOST_STOLEN_MODAL_SUMMARY_FORM = 'LOST_STOLEN_MODAL_SUMMARY_FORM'
export const LOST_STOLEN_MODAL_SHIPPING_FORM = 'LOST_STOLEN_MODAL_SHIPPING_FORM'
export const LOST_STOLEN_MODAL_REPLACEMENT_FORM =
  'LOST_STOLEN_MODAL_REPLACEMENT_FORM'
